//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getSubPage from '../mixins/getSubPage'
export default {
    mixins: [
        getSubPage
    ],
    methods: {
        tabLog (e) {
            this.$emit('tabLog', e)
        },
        goQulification (e) {
            this.tabLog(e)
            this.$router.push({
                path:'/pages/check_condition/main'
            })
        },
        goMaterial (e) {
            this.tabLog(e)
            this.goSubPagePath(`/building/material?building_id=${this.house.id}&house_id=${this.current_house.id}`)
        },
        goHousePrice (e) {
            const { id: building_id, name } = this.house
            const { id: house_id } = this.current_house
            this.tabLog(e)
            this.goSubPagePath(`/building/price?building_id=${building_id}&title=${name}&house_id=${house_id}`)
        },
    },
    props: {
        current_house: {
            type: Object
        },
        house: {
            type: Object
        }
    }
}
